import { render, staticRenderFns } from "./EventClassSelection.vue?vue&type=template&id=ded76488&scoped=true"
import script from "./EventClassSelection.vue?vue&type=script&lang=ts"
export * from "./EventClassSelection.vue?vue&type=script&lang=ts"
import style0 from "./EventClassSelection.vue?vue&type=style&index=0&id=ded76488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded76488",
  null
  
)

export default component.exports